import { createStore, combineReducers } from 'redux'
import userReducer from "./user-reducer";

let store = createStore(combineReducers({
    userReducer: userReducer,
}));

window.store = store.getState();
export default store;